type Props = {
  label: string | undefined;
};
export default function FilterItemLabel({ label = "" }: Props) {
  return <div className="text-gray-B text-xs font-bold">{label}</div>;
}
